import { render } from "./TemperatureCard.vue?vue&type=template&id=3b8cd490&scoped=true"
import script from "./TemperatureCard.vue?vue&type=script&lang=js"
export * from "./TemperatureCard.vue?vue&type=script&lang=js"

import "./TemperatureCard.vue?vue&type=style&index=0&id=3b8cd490&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8cd490"]])

export default __exports__